export default "__VITE_ASSET__DvYMYkaG__"